import { defineComponent as _defineComponent } from 'vue';
import ToggleButton from "primevue/togglebutton";
import Button from "primevue/button";
import { onMounted, ref } from "vue";
import { useGoogleMaps } from "@/Plugins/google-maps";
import { useForm, usePage } from "@inertiajs/inertia-vue3";
import CompanyService from "@/Services/CompanyService";
import { useSpinner } from "@/Plugins/spinner";
import useVuelidate from "@vuelidate/core";
import { required } from "@/i18n-validators";
import InputTextVue from "@/Components/InputText.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Form',
    props: {
        modelValue: Object,
    },
    emits: ["cancel", "saved"],
    setup(__props, { expose, emit }) {
        expose();
        const props = __props;
        const googleMaps = useGoogleMaps();
        const companyService = new CompanyService();
        const page = usePage();
        const user = page.props.value.auth.user;
        const isAdmin = user.admin;
        const spinner = useSpinner();
        const value = ref((props.modelValue || {}));
        const form = useForm({
            enabled: value.value.enabled ?? true,
            name: value.value.name,
            address: value.value.address,
            place: value.value.place,
            postal_code: value.value.postal_code,
            city: value.value.city,
            state: value.value.state,
            country: value.value.country,
            tax_code: value.value.tax_code,
            vat_number: value.value.vat_number,
        });
        const rules = {
            enabled: { required },
            name: { required },
            address: { required },
            place: { required },
            postal_code: { required },
            city: { required },
            state: { required },
            country: { required },
            tax_code: { required },
            vat_number: { required },
        };
        const v$ = useVuelidate(rules, form);
        const submitted = ref(false);
        const addressInput = ref();
        const autocompleteOptions = {
            fields: ["address_components", "formatted_address"],
            types: ["address"],
        };
        onMounted(() => {
            const addressFieldEl = addressInput.value.$el;
            const addressInputEl = addressFieldEl
                .getElementsByTagName("input")
                .item(0);
            if (addressInputEl) {
                const autocomplete = new googleMaps.maps.places.Autocomplete(addressInputEl, autocompleteOptions);
                autocomplete.addListener("place_changed", () => {
                    const place = autocomplete.getPlace();
                    setAddressFromPlace(place);
                });
            }
        });
        const setAddressFromPlace = (place) => {
            form.country = googleMaps.getCountry(place)?.long_name ?? "";
            form.state = googleMaps.getState(place)?.long_name ?? "";
            form.city = googleMaps.getCity(place)?.long_name ?? "";
            form.place = googleMaps.getLocality(place)?.long_name ?? "";
            if (!form.place) {
                form.place = form.city;
            }
            form.postal_code = googleMaps.getPostalCode(place)?.long_name ?? "";
            form.address = googleMaps.getStreetAddress(place) ?? "";
        };
        const submit = async () => {
            submitted.value = true;
            const isFormValid = await v$.value.$validate();
            if (!isFormValid) {
                return;
            }
            spinner.show();
            if (value.value.id) {
                companyService.update(value.value.id, form.data())
                    .then((result) => {
                    emit("saved", result.data.data);
                })
                    .finally(() => spinner.hide());
            }
            else {
                companyService.store(form.data())
                    .then((result) => {
                    emit("saved", result.data.data);
                })
                    .finally(() => spinner.hide());
            }
        };
        const __returned__ = { googleMaps, props, emit, companyService, page, user, isAdmin, spinner, value, form, rules, v$, submitted, addressInput, autocompleteOptions, setAddressFromPlace, submit, get ToggleButton() { return ToggleButton; }, get Button() { return Button; }, InputTextVue };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
